import { sub } from 'date-fns';

import { CUSTOM_DATES_TITLE } from '~/fleet-manager/components/common/dateFilterMenuItems';

export function getDateFilterDates(
  selectedDateRange: { start: Duration; end?: Duration } | undefined,
  dateFilterSearchParam: string | null,
  defaultCurrentDate?: Date
) {
  const customSelectedDate = dateFilterSearchParam?.includes(CUSTOM_DATES_TITLE)
    ? dateFilterSearchParam.split('|').filter((str) => str !== CUSTOM_DATES_TITLE)
    : undefined;

  const currentDate = defaultCurrentDate || new Date();
  currentDate.setMilliseconds(0);

  const { start: activeFilterStartDuration, end: activeFilterEndDuration } =
    selectedDateRange || {};

  const endDurationKey = Object.keys(activeFilterEndDuration || {})[0] as keyof Duration;

  const calculatedEndDuration =
    activeFilterEndDuration?.minutes && currentDate.getMinutes() < activeFilterEndDuration?.minutes
      ? { [endDurationKey]: currentDate.getMinutes() }
      : activeFilterEndDuration?.seconds &&
          currentDate.getSeconds() < activeFilterEndDuration?.seconds
        ? { [endDurationKey]: currentDate.getSeconds() }
        : { [endDurationKey]: 0 };

  const selectedDates = customSelectedDate
    ? customSelectedDate
    : [
        sub(currentDate, activeFilterStartDuration || { hours: 3 }).toISOString(),
        activeFilterEndDuration
          ? sub(currentDate, calculatedEndDuration).toISOString()
          : currentDate.toISOString(),
      ];

  return selectedDates;
}
